import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './Overlay.module.scss';

const Overlay = ({ children, theme = {}, isOffset }) => {
  const overlayClasses = [style.overlay, theme.overlay];
  if (isOffset) overlayClasses.push(style.overlayOffset);
  return <div className={classNames(overlayClasses)}>{children}</div>;
};

Overlay.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({}),
  isOffset: PropTypes.bool,
};

export default Overlay;
